import styled from 'styled-components'

export const Button = styled.button<{ selected: boolean }>`
  border: none;

  padding: 8px 16px;
  border-radius: 40px;

  background-color: ${(props) =>
    props.selected ? props.theme.colors.primary : props.theme.colors.white};

  border: 1px solid ${(props) => props.theme.colors.darkgray};

  font-size: ${(props) => props.theme.fontSizes.b4};
  font-weight: ${(props) => props.theme.fontWeights.semibold};

  transition: all 0.8s;
`
